import { Link } from 'react-router';
import { nomeParceiro } from '../nucleo/formato';

/**
 * Fase 2 (W20, mesma classe da review r16 robustez M3): o parceiro de um registro visível, com o link para a ficha. Quando o
 * servidor manda o nome nulo (parceiro de uma empresa que a pessoa não vê), mostra o rótulo neutro "Cadastro de outra empresa"
 * sem o link (a ficha responderia 404). O nome passa por `nomeParceiro` (iniciais no modo discreto com a opção de nomes).
 */
export function LinkParceiro({ id, nome, className = 'text-acento-forte hover:underline', title, para }: { id: string; nome: string | null | undefined; className?: string; title?: string; /** Ajustes do CRM (27/10): outro destino (a página do contato no CRM); sem ele, a ficha do Cadastros. */ para?: string }) {
  if (nome === null || nome === undefined) return <span className="text-tinta-2">{nomeParceiro(nome)}</span>;
  return (
    <Link to={para ?? `/cadastros/cadastros/parceiro/${id}`} className={className} title={title}>
      {nomeParceiro(nome)}
    </Link>
  );
}
